import { PRODUCT_NEW_STEPS_FLOW } from '../core/pages/ProductNew-v2/constants'

export default PRODUCT_NEW_STEPS_FLOW
